export interface methodsLabelSummaryOfTotalsTable {
  label: string;
  hasCurrency: boolean;
}
